module.exports = __webpack_public_path__ + "37ba7b92/img/chevron-right-icon.253a4260.svg";